<template>
  <div class="app-change-tariff-input">
    <h1>Tarifwechsel</h1>
    <div v-if="tariffs">
      <div id="booked-tariff">
        <div id="book-tariff-desc">
          <slot name="txtBookedTariff">
            <div class="stoerer">Ihr Tarif</div>
            <h2>Aktuell nutzen Sie den Tarif</h2>
          </slot>
          <p>{{ tariffs.bookedTariff.name }}</p>
          <div class="booked-tariff-image"><img :src="bookedTariffImage"></div>
        </div>
      </div>
      <div id="change-tariff">
        <div class="stoerer">Tarif ändern</div>
        <div class="bookable-tariffs">
          <slot name="txtBeforeBookableTariffs"><h2>Sie können in folgende Tarife wechseln:</h2></slot>
          <div v-if="tariffs.bookableTariffs.bookableTariffs.length > 0" class="input-bookable-tariffs">
            <fieldset class="form-group">
              <div class="row">
                <div class="tariff-change">
                  <b-form-group>
                    <b-form-radio-group v-model="checked" stacked >
                      <div v-for="tariff in tariffs.bookableTariffs.bookableTariffs" :key="tariff.tariffId">
                        <b-form-radio name="change-tariff" :value="tariff.tariffId">{{ tariff.name }}</b-form-radio>
                      </div>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="bookable-tarif-image">
                  <img :src="decodedExtra.extraData.changeTariffImgURL">
                </div>
              </div>
            </fieldset>
            <slot name="txtAfterBookableTariffs"></slot>
          </div>
          <div v-else>
            <slot name="txtBookableTariffsElse">
              <p>Sie können derzeit in keinen anderen Tarif wechseln.</p>
            </slot>
          </div>
        </div>
      </div>
      <Stepper
        @next="next()"
        :showPrev="false"
        :loading-next="loading"
      >
        <template #btnNext><slot name="btnNext"></slot></template>
      </Stepper>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapActions, mapMutations } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'
import processSteps from '@/mixins/processSteps'
import { stepName as nextStep } from '@/components/process/generic/Tariff/rossmann/Summary.vue'
import { BFormGroup, BFormRadio, BFormRadioGroup } from 'bootstrap-vue'
import preFilledInput from '@/mixins/preFilledInput'

export const stepName = 'input'

export default {
  name: 'ChangeTariffInput',
  components: {
    Stepper, BFormGroup, BFormRadioGroup, BFormRadio
  },
  props: {
    extra: {
      type: String
    }
  },
  data: function () {
    return {
      tariffs: null,
      loading: false,
      decodedExtra: {}
    }
  },
  created () {
    try {
      this.decodedExtra = JSON.parse(atob(this.extra))
    } catch (e) {
      this.decodedExtra = {}
    }
  },
  computed: {
    bookedTariffImage: function () {
      return this.decodedExtra?.extraData?.tariffs.find(item => (item.tariffId === +this.tariffs.bookedTariff.tariffId))?.imgURL || null
    },
    checkedName: function () {
      return this.tariffs?.bookableTariffs?.bookableTariffs?.find(item => item.tariffId === this.checked)?.name || null
    },
    firstBookableTariff () {
      return this.tariffs.bookableTariffs.bookableTariffs[0].tariffId
    }
  },
  methods: {
    ...mapActions('changeTariff', [
      'changeTariff'
    ]),
    ...mapMutations('changeTariff', [
      'changeStep'
    ]),
    async next () {
      this.loading = true
      const response = await this.changeTariff({
        tariffId: this.checked,
        tariffName: this.checkedName
      })
      if (response.success === true) {
        this.changeStep(nextStep)
      }
      this.loading = false
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(gql`query changeTariff{
        tariffs {
          bookableTariffs {
            bookableTariffs {
              name,
              tariffId
            }
          },
          bookedTariff {
            tariffId,
            name
          }
        }
      }`, this, 'tariffs')
    }
  },
  mixins: [
    processSteps(stepName, stepName, nextStep),
    preFilledInput('checked', 'firstBookableTariff')
  ]
}
</script>
